
import MainIndex from "../pages";
import MLandingPage from "../pages/landing/page";
import NotFoundPage from "../pages/notFound";

export const routes = [
  {
    path: "/",
    element: <MainIndex />,
    nestedRoutes: [{ path: undefined, element: undefined }],
  },
  {
    path: "/landing",
    element: <MLandingPage />,
    nestedRoutes: [{ path: undefined, element: undefined }],
  },
  {
    path: "/*",
    element: <NotFoundPage />,
    nestedRoutes: [{ path: undefined, element: undefined }],
  },
];